<template>
  <v-dialog
    v-model="orderTrackingStore.viewDialogModel"
    :persistent="orderTrackingStore.viewDialogLoading"
    max-width="650"
    class="elevation-0"
    scrollable
    overlay-opacity="0.6"
    attach=""
  >
    <v-card
      rounded="xl"
      flat
      :disabled="orderTrackingStore.viewDialogLoading"
      :class="{
        'scrollable-card': !isScroll,
        'scrollable-text-card': !isScroll && $vuetify.breakpoint.mdAndDown,
        'scrollable-not-card': !isScroll && arrivedState.bottom,
      }"
    >
      <v-card-title class="grey">
        <h4 class="text-body-1 text-sm-h6 font-weight-bold">Sipariş Detay</h4>

        <v-spacer />

        <v-btn
          v-if="$vuetify.breakpoint.smAndUp"
          rounded
          small
          depressed
          color="chip"
          class="text-capitalize"
          @click="orderTrackingStore.viewDialogClose"
        >
          <v-icon left>{{ icons.mdiClose }}</v-icon>
          Kapat
        </v-btn>
        <v-icon v-else small @click="orderTrackingStore.viewDialogClose">{{
          icons.mdiClose
        }}</v-icon>
      </v-card-title>

      <v-divider />
      <v-card-text
        class="pa-0"
        ref="scrollableEl"
        :style="
          $vuetify.breakpoint.smAndUp ? 'height: 735px' : 'height: 100dvh'
        "
      >
        <v-list>
          <v-list-item class="px-3 px-md-6">
            <v-list-item-content>
              <v-list-item-subtitle>Cari Unvan</v-list-item-subtitle>
              <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp">{{
                orderTrackingStore.viewDialogData.customer_name
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
              {{ orderTrackingStore.viewDialogData.customer_name }}
            </v-list-item-action>
          </v-list-item>
          <v-divider />

          <v-list-item class="px-3 px-md-6">
            <v-list-item-content>
              <v-list-item-subtitle>Cari Kullanıcı Adı</v-list-item-subtitle>
              <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp">{{
                orderTrackingStore.viewDialogData.customer_username.slice(0, -3)
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
              {{
                orderTrackingStore.viewDialogData.customer_username.slice(0, -3)
              }}
            </v-list-item-action>
          </v-list-item>
          <v-divider />

          <v-list-item class="px-3 px-md-6">
            <v-list-item-content>
              <v-list-item-subtitle>Cari Kod</v-list-item-subtitle>
              <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp">{{
                orderTrackingStore.viewDialogData.cari_kod
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
              <v-chip
                label
                color="grey"
                class="d-flex justify-center text-caption"
              >
                <span
                  class="text-caption text-xl-subtitle-2"
                  style="letter-spacing: 0.5px; color: azure"
                  >{{ orderTrackingStore.viewDialogData.cari_kod }}</span
                >
              </v-chip>
            </v-list-item-action>
          </v-list-item>
          <v-divider />
          <v-list-item class="px-3 px-md-6" two-line>
            <v-list-item-content>
              <v-list-item-subtitle>Sipariş Durum</v-list-item-subtitle>

              <v-list-item-subtitle
                :class="`d-flex align-center text-caption ${orderTrackingStore.viewDialogData.order_status}--text`"
              >
                <v-icon
                  small
                  v-if="$vuetify.breakpoint.smAndUp"
                  class="me-2"
                  :color="orderTrackingStore.viewDialogData.order_status"
                  >{{ icons.mdiInformationVariantCircle }}</v-icon
                >
                {{ orderTrackingStore.viewDialogData.order_msg }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-chip
                :color="orderTrackingStore.viewDialogData.order_status"
                label
                class="d-flex justify-center text-caption"
                style="
                  font-size: 11px !important;
                  letter-spacing: 1.5px;
                  color: azure;
                "
              >
                {{ orderTrackingStore.viewDialogData.order_status_text }}
              </v-chip>
            </v-list-item-action>
          </v-list-item>
          <v-divider />
          <v-list-item class="px-3 px-md-6">
            <v-list-item-content>
              <v-list-item-subtitle>Sipariş Tipi</v-list-item-subtitle>
              <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp">{{
                orderTrackingStore.viewDialogData.mattype
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
              <v-chip
                :color="
                  orderTrackingStore.viewDialogData.mattype === 'MAMUL'
                    ? 'secondary'
                    : orderTrackingStore.viewDialogData.mattype === 'SARF'
                    ? '#1f6388'
                    : 'error'
                "
                label
                class="d-flex justify-center text-caption"
                style="
                  font-size: 11px !important;
                  letter-spacing: 1.5px;
                  color: azure;
                "
              >
                {{ orderTrackingStore.viewDialogData.mattype || "BELİRSİZ" }}
              </v-chip>
            </v-list-item-action>
          </v-list-item>
          <v-divider />

          <v-list-item class="px-3 px-md-6">
            <v-list-item-content>
              <v-list-item-subtitle
                >Sipariş Numarası (CNS)</v-list-item-subtitle
              >
              <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp">{{
                orderTrackingStore.viewDialogData.order_no
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
              <v-chip
                label
                color="grey"
                class="d-flex justify-center text-caption"
              >
                <span
                  class="text-caption text-xl-subtitle-2"
                  style="letter-spacing: 0.5px; color: azure"
                  >{{ orderTrackingStore.viewDialogData.order_no }}</span
                >
              </v-chip>
            </v-list-item-action>
          </v-list-item>
          <v-divider />

          <v-list-item class="px-3 px-md-6">
            <v-list-item-content>
              <v-list-item-subtitle>Sipariş Numarası</v-list-item-subtitle>
              <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp">{{
                orderTrackingStore.viewDialogData.id
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
              <v-chip
                label
                color="grey"
                class="d-flex justify-center text-caption"
              >
                <span
                  class="text-caption text-xl-subtitle-2"
                  style="letter-spacing: 0.5px; color: azure"
                  >{{ orderTrackingStore.viewDialogData.id }}</span
                >
              </v-chip>
            </v-list-item-action>
          </v-list-item>
          <v-divider />

          <v-list-item class="px-3 px-md-6">
            <v-list-item-content>
              <v-list-item-subtitle>Sipariş Tarihi</v-list-item-subtitle>
              <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp">{{
                orderTrackingStore.viewDialogData.siparis_tarihi
                  | moment("DD.MM.YYYY - HH:mm")
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
              <v-chip color="grey" class="d-flex justify-center" label>
                <div
                  class="d-flex align-center"
                  style="
                    text-align: center;
                    font-size: 11px !important;
                    letter-spacing: 0.5px;
                    color: azure;
                  "
                >
                  <v-icon color="" small class="mr-2">
                    {{ icons.mdiCalendarClock }}
                  </v-icon>
                  <div class="mr-1">
                    {{
                      orderTrackingStore.viewDialogData.siparis_tarihi
                        | moment("DD.MM.YYYY ")
                    }}
                  </div>

                  <span>
                    -
                    {{
                      orderTrackingStore.viewDialogData.siparis_tarihi
                        | moment("HH:mm")
                    }}</span
                  >
                </div>
              </v-chip>
            </v-list-item-action>
          </v-list-item>
          <v-divider />

          <v-list-item class="px-3 px-md-6">
            <v-list-item-content>
              <v-list-item-subtitle>Sipariş Kalem Sayısı</v-list-item-subtitle>
              <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp"
                >{{
                  orderTrackingStore.viewDialogData.kalem_sayisi
                }}
                Adet</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
              <v-chip
                color="#9391a2"
                outlined
                class="d-flex justify-center"
                label
              >
                <div
                  class="text-capitalize"
                  style="text-align: center; font-size: 11px !important"
                >
                  {{ orderTrackingStore.viewDialogData.kalem_sayisi }} Adet
                </div>
              </v-chip>
            </v-list-item-action>
          </v-list-item>
          <v-divider />

          <v-list-item class="px-3 px-md-6">
            <v-list-item-content>
              <v-list-item-subtitle>Sipariş Tutar</v-list-item-subtitle>
              <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp"
                >{{ orderTrackingStore.viewDialogData.total_price | currency }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
              {{ orderTrackingStore.viewDialogData.total_price | currency }}
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-sheet
          class="mx-auto"
          width="95%"
          v-if="orderTrackingStore.viewDialogData.buyer_note"
        >
          <v-card color="chip" rounded="lg">
            <v-card-title>Pasta Özellikleri</v-card-title>
            <v-divider />

            <v-list color="transparent">
              <v-list-item class="px-3 px-md-6">
                <v-list-item-content>
                  <v-list-item-subtitle>Kişi Sayısı</v-list-item-subtitle>
                  <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp"
                    >{{
                      orderTrackingStore.viewDialogData.products[0].qty.slice(
                        0,
                        -3
                      )
                    }}
                    Kişilik
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                  {{
                    orderTrackingStore.viewDialogData.products[0].qty.slice(
                      0,
                      -3
                    )
                  }}
                  Kişilik
                </v-list-item-action>
              </v-list-item>
              <v-list-item class="px-3 px-md-6">
                <v-list-item-content>
                  <v-list-item-subtitle>Pasta Şekli</v-list-item-subtitle>
                  <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp"
                    >{{
                      orderTrackingStore.viewDialogData.buyer_note.cakeShape
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                  {{ orderTrackingStore.viewDialogData.buyer_note.cakeShape }}
                </v-list-item-action>
              </v-list-item>

              <v-list-item class="px-3 px-md-6">
                <v-list-item-content>
                  <v-list-item-subtitle>Pasta Keki</v-list-item-subtitle>
                  <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp"
                    >{{ orderTrackingStore.viewDialogData.buyer_note.cakeCake }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                  {{ orderTrackingStore.viewDialogData.buyer_note.cakeCake }}
                </v-list-item-action>
              </v-list-item>
              <v-list-item class="px-3 px-md-6">
                <v-list-item-content>
                  <v-list-item-subtitle>Pasta Kreması</v-list-item-subtitle>
                  <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp"
                    >{{
                      orderTrackingStore.viewDialogData.buyer_note.cakeCream
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                  {{ orderTrackingStore.viewDialogData.buyer_note.cakeCream }}
                </v-list-item-action>
              </v-list-item>

              <v-list-item
                class="px-3 px-md-6"
                v-if="orderTrackingStore.viewDialogData.buyer_note.cakeContents"
              >
                <v-list-item-content>
                  <v-list-item-subtitle>Pasta Seçenekleri</v-list-item-subtitle>
                  <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp"
                    >{{
                      parseJson(
                        orderTrackingStore.viewDialogData.buyer_note
                          .cakeContents
                      )
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                  {{
                    parseJson(
                      orderTrackingStore.viewDialogData.buyer_note.cakeContents
                    )
                  }}
                </v-list-item-action>
              </v-list-item>

              <v-list-item class="px-3 px-md-6">
                <v-list-item-content>
                  <v-list-item-subtitle>Teslim Tarihi</v-list-item-subtitle>
                  <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp"
                    >{{
                      orderTrackingStore.viewDialogData.teslim_tarihi.slice(
                        0,
                        11
                      )
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                  {{
                    orderTrackingStore.viewDialogData.teslim_tarihi.slice(0, 11)
                  }}
                </v-list-item-action>
              </v-list-item>

              <v-list-item class="px-3 px-md-6">
                <v-list-item-content>
                  <v-list-item-subtitle>Pasta Açıklaması</v-list-item-subtitle>
                  <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp"
                    >{{
                      orderTrackingStore.viewDialogData.buyer_note.contentNote
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                  {{ orderTrackingStore.viewDialogData.buyer_note.contentNote }}
                </v-list-item-action>
              </v-list-item>
              <v-list-item class="px-3 px-md-6">
                <v-list-item-content>
                  <v-list-item-subtitle
                    >Sipariş Açıklaması</v-list-item-subtitle
                  >
                  <v-list-item-title v-if="!$vuetify.breakpoint.smAndUp"
                    >{{
                      orderTrackingStore.viewDialogData.buyer_note.orderNote
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                  {{ orderTrackingStore.viewDialogData.buyer_note.orderNote }}
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-card
              v-for="(item, i) in orderTrackingStore.viewDialogData.buyer_note
                .files"
              :key="i"
              color="transparent"
              class="pa-6"
            >
              <v-img :src="$baseUrlAPI + '' + item" class="rounded-lg" />
            </v-card>
          </v-card>
        </v-sheet>

        <div style="position: relative">
        <v-list color="">
          <v-subheader
            class="px-3 px-md-6 d-flex align-center justify-space-between text-subtitle-1 text-md-h6 white--text"
          >
            <span>Sipariş Edilen Ürünler</span>
            <div>
              <v-btn
                v-if="!returnMode && canShowReturnButton "
                small
                rounded
                depressed
                color="info"
                class="text-capitalize"
                :loading="refundInvQtyLoading"
                :disabled="refundInvQtyLoading"
                @click="toggleReturnMode()"
              >
                <v-icon left>{{ icons.mdiUndoVariant }}</v-icon>
                İade Et
              </v-btn>
              <v-btn
                v-else-if="returnMode && canShowReturnButton "
                small
                text
                color="white"
                class="text-capitalize"
                @click="toggleReturnMode(true)"
              >Vazgeç</v-btn>
            </div>
          </v-subheader>
          <div
            v-for="(item, index) in orderTrackingStore.viewDialogData.products"
            :key="`wrap-${index}`"
            :style="refundInvQtyLoading ? 'opacity: 0.4; pointer-events: none' : ''"
          >
            <v-divider />
            <v-list-item
              class="px-3 px-md-6 py-0 py-md-2"
              three-line
            >
              <!-- Checkbox sadece iade seçilebilir ürünlerde gösterilsin -->
              <v-list-item-action
                v-if="returnMode && canSelectForReturn(item)"
                class="mr-3"
                style="min-width: 36px"
              >
                <v-checkbox
                  dense
                  hide-details
                  class="ma-0 pa-0"
                  v-model="selectedMap[item.id]"
                  :disabled="refundInvQtyLoading"
                  @change="onCheckboxChange(item, $event)"
                />
              </v-list-item-action>
              <v-list-item-avatar
                tile
                :height="$vuetify.breakpoint.smAndUp ? 75 : 50"
                :width="$vuetify.breakpoint.smAndUp ? 75 : 50"
                color="white"
                class="rounded-lg mr-3"
              >
                <v-avatar tile :height="60" :width="60">
                  <v-img
                    v-if="item.resim"
                    :src="$baseUrlAPI + '' + item.resim"
                    class="rounded-lg"
                  />
                  <v-icon v-else size="30" color="primary">
                    {{ icons.mdiCameraOff }}</v-icon
                  >
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title style="white-space: normal">
                  <div class="text-caption mb-1">
                    <v-chip
                      label
                      :small="$vuetify.breakpoint.smAndUp"
                      :x-small="!$vuetify.breakpoint.smAndUp"
                      :color="ERP_ORDER_TYPE_DETAILS(item.erporderno, 'color')"
                      style="font-size: 10px"
                      >{{
                        ERP_ORDER_TYPE_DETAILS(item.erporderno, "text")
                      }}</v-chip
                    > <span v-if="item.erporderno && item.erporderno.length > 10"  class="text-subtitle-2"> -  {{ item.erporderno }}</span>
                  </div>
                  <div
                    class="text-caption text-sm-subtitle-2 white--text"
                    style="white-space: normal; word-break: break-word"
                  >
                    {{ item.baslik }}
                  </div>
                  <div
                    class="text-caption"
                    v-if="$vuetify.breakpoint.smAndUp && item.kategori_path"
                  >
                    {{ item.prd_code }} - {{ item.kategori_path.split(",")[1] }}
                  </div>
                  <div v-else class="text-caption">
                    <span>
                      {{ Number(item.qty) }}
                      <span v-if="item.birim">
                        {{
                          $store.state.tanimlar.birim.find(
                            (el) => el.value === item.birim
                          ).text
                        }}
                      </span>
                      <span v-else>Tanımsız</span>
                    </span>
                    <v-chip
                      x-small
                      color="info"
                      label
                      class="ml-1"
                      v-if="returnMode && selectedMap[item.id]"
                    >
                      {{ formatQty(returnQtyMap[item.id] || 0) + ' ' + getReturnUnitText(item) + ' İade' }}
                    </v-chip>
                    <v-chip
                      x-small
                      label
                      class="ml-1"
                      :color="refundStatusMeta(item.refund_status_code, item.refund_status_txt).color"
                      v-if="Number(item.refund_qty) > 0"
                    >
                      {{
                        (Number(item.refund_qty)) +
                        ' ' +
                        getUnitText(item) +
                        ' iade - ' +
                        refundStatusMeta(item.refund_status_code, item.refund_status_txt).text
                      }}
                    </v-chip>
                    <span> - {{ item.total_price | currency }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                <template v-if="returnMode && selectedMap[item.id]">
                  <v-list-item-action-text>
                    {{ Number(item.qty) }}
                    <span v-if="item.birim">
                      {{
                        $store.state.tanimlar.birim.find(
                          (el) => el.value === item.birim
                        ).text
                      }}
                    </span>
                    <span v-else>Tanımsız</span>
                  </v-list-item-action-text>
                  <v-list-item-action-text>
                    <div class="text-overline white--text">
                      {{ item.total_price | currency }}
                    </div>
                  </v-list-item-action-text>

                  <v-chip x-small color="info" label class="mr-2">
                    {{ formatQty(returnQtyMap[item.id] || 0) + ' ' + getReturnUnitText(item) + ' İade' }}
                  </v-chip>
                </template>
                <template v-else>
                  <v-list-item-action-text>
                    {{ Number(item.qty) }}
                    <span v-if="item.birim">
                      {{
                        $store.state.tanimlar.birim.find(
                          (el) => el.value === item.birim
                        ).text
                      }}
                    </span>
                    <span v-else>Tanımsız</span>
                  </v-list-item-action-text>
                  <v-list-item-action-text>
                    <div class="text-overline white--text">
                      {{ item.total_price | currency }}
                    </div>
                  </v-list-item-action-text>
                  <v-chip
                    x-small
                    label
                    class="mt-1"
                    :color="refundStatusMeta(item.refund_status_code, item.refund_status_txt).color"
                    v-if="Number(item.refund_qty) > 0"
                  >
                    {{
                      (Number(item.refund_qty)) +
                      ' ' +
                      getUnitText(item) +
                      ' iade - ' +
                      refundStatusMeta(item.refund_status_code, item.refund_status_txt).text
                    }}
                  </v-chip>
                </template>
              </v-list-item-action>
            </v-list-item>
            <div
              v-if="returnMode && selectedMap[item.id]"
              class="px-3 px-md-6 pb-3"
              style="max-width: 100%"
            >
              <v-divider
                class="my-3"
                style="opacity: 0.5; border-color: rgba(255, 255, 255, 0.22)"
              />
              <div
                class="d-flex flex-wrap align-center"
                style="gap: 10px 16px; max-width: 100%"
              >
                <v-checkbox
                  v-if="canChangeUnit(item)"
                  dense
                  hide-details
                  class="ma-0 pa-0"
                  :input-value="!!unitChangeMap[item.id]"
                  label="Birim Değiştir"
                  @change="onUnitChangeToggle(item, $event)"
                />
                <div class="d-flex align-center" style="gap: 8px">
                  <span class="text-caption" style="opacity: 0.9; white-space: nowrap">
                    İade
                  </span>
                  <v-text-field
                    v-model.number="returnQtyMap[item.id]"
                    type="number"
                    dense
                    hide-details="auto"
                    class="ma-0"
                    style="width: 76px; min-width: 76px; max-width: 76px"
                    min="0"
                    step="any"
                    :max="getMaxReturnQty(item)"
                    :error="!!qtyErrorMessage(item)"
                    :error-messages="
                      qtyErrorMessage(item) ? [qtyErrorMessage(item)] : []
                    "
                    @blur="clampQty(item)"
                  />
                  <span
                    v-if="!unitChangeMap[item.id]"
                    class="text-caption"
                    style="opacity: 0.9; white-space: nowrap"
                  >
                    {{ getReturnUnitText(item) }}
                  </span>
                  <v-select
                    v-else
                    :value="altUnitMap[item.id]"
                    :items="getUnitSelectItems(item)"
                    item-text="text"
                    item-value="value"
                    dense
                    hide-details
                    class="ma-0"
                    style="width: 118px; min-width: 118px; max-width: 130px"
                    :menu-props="{ offsetY: true, maxHeight: 280 }"
                    @change="onAltUnitChange(item, $event)"
                  />
                </div>
                <div class="text-caption" style="white-space: nowrap">
                  Faturalanmış
                  <span class="text-subtitle-2 white--text ml-1">
                    {{ formatQty(getMaxReturnQty(item)) }}
                    {{ getReturnUnitText(item) }}
                  </span>
                </div>
                <v-select
                  v-model="reasonMap[item.id]"
                  :items="refundReasonList"
                  item-text="text"
                  item-value="value"
                  dense
                  outlined
                  hide-details="auto"
                  class="ma-0"
                  style="flex: 1 1 180px; min-width: 160px; max-width: 100%"
                  label="İade Nedeni"
                  placeholder="İade nedeni seçiniz"
                  :menu-props="{ maxHeight: 360, offsetY: true }"
                  :loading="refundReasonLoading"
                  :disabled="refundReasonLoading || refundReasonList.length === 0"
                  :error="showMissingReasons && !reasonMap[item.id]"
                  :error-messages="
                    showMissingReasons && !reasonMap[item.id]
                      ? ['İade nedeni seçiniz']
                      : []
                  "
                />
              </div>
              <div
                v-if="unitChangeMap[item.id] && getConversionLabels(item).length"
                class="d-flex flex-wrap align-center mt-2"
                style="gap: 6px"
              >
                <v-chip
                  v-for="(line, ci) in getConversionLabels(item)"
                  :key="`conv-${item.id}-${ci}`"
                  x-small
                  label
                  outlined
                >
                  {{ line }}
                </v-chip>
              </div>
            </div>
          </div>
        </v-list>
        <v-overlay
          :value="refundInvQtyLoading"
          absolute
          opacity="0.45"
          color="#1E1E2D"
        >
          <v-progress-circular indeterminate color="primary" />
        </v-overlay>
        </div>

        <div
          class="text-center pt-1"
          v-if="userData.role === 'SUPER' || userData.role === 'COMMAN'"
        >
          <v-btn plain @click="deleteItem" class="text-capitalize">
            <v-icon size="24" left>
              {{ icons.mdiDeleteOutline }}
            </v-icon>
            Siparişi Sil</v-btn
          >
        </div>
      </v-card-text>
      <v-card-actions v-if="returnMode" class="px-3 px-md-6">
        <v-spacer />
        <v-btn text class="text-capitalize" @click="toggleReturnMode(true)">Vazgeç</v-btn>
        <v-btn
          color="info"
          depressed
          rounded
          class="text-capitalize"
          :disabled="selectedCount === 0 || refundInvQtyLoading || hasMissingReasons || !isValidSelection"
          :loading="orderTrackingStore.viewDialogLoading"
          @click="createReturnRequest"
        >
          İade Talebi Oluştur
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, onMounted, computed, watch } from "vue-demi";
import Vue from "vue";
import store from "@/store";

// Pinia
import { useOrderTrackingStore } from "./../_orderTrackingStore";

// Utils
import { useScroll, useResizeObserver } from "@vueuse/core";
import { postData } from "@utils";

// Icons
import {
  mdiClose,
  mdiTrashCan,
  mdiInformationVariantCircle,
  mdiCalendarClock,
  mdiCameraOff,
  mdiDeleteOutline,
  mdiUndoVariant,
} from "@mdi/js";

export default {
  setup(props, { emit }) {
    // Pinia
    const orderTrackingStore = useOrderTrackingStore();

    const deleteItem = () => {
      emit("deleteItem");
    };

    const scrollableEl = ref(null);
    const userData = JSON.parse(localStorage.getItem("userData"));
    // Kaydırma çubuğu
    const { arrivedState } = useScroll(scrollableEl);
    const isScroll = ref(false);
    onMounted(() => {
      isScroll.value =
        scrollableEl.value?.scrollHeight === scrollableEl.value?.offsetHeight;
    });

    // Ekran boyutu algılama
    useResizeObserver(scrollableEl, (entries) => {
      isScroll.value =
        scrollableEl.value?.scrollHeight === scrollableEl?.value.offsetHeight;
    });
    const parseJson = (item) => {
      let text = "";
      item.forEach((element) => {
        text += JSON.parse(element).text + ", ";
      });

      return text.slice(0, -2);
    };

    const ERP_ORDER_TYPE_DETAILS = (type, field) => {
      const types = {
        ERR: { text: "HATALI", color: "error" },
        null: { text: "İŞLENİYOR", color: "warning" },
      };
      const orderType = types[type] || { text: "BAŞARILI", color: "success" };

      if (orderType[field]) {
        return orderType[field];
      }

      console.warn(
        `Invalid field '${field}' requested. Returning 'undefined'.`
      );
      return undefined;
    };

    // İade Modu Durumları
    const returnMode = ref(false);
    const selectedMap = ref({});
    const returnQtyMap = ref({});
    const reasonMap = ref({});
    const refundReasonList = ref([]);
    const refundReasonLoading = ref(false);
    const refundReasonLoaded = ref(false);
    const refundInvQtyLoading = ref(false);
    const invQtyMap = ref({});
    const unitChangeMap = ref({});
    const altUnitMap = ref({});
    const showMissingReasons = ref(false);

    const normalizeRefundReasonList = (source) => {
      if (!source) return [];

      if (Array.isArray(source)) {
        return source
          .map((r) => {
            const value =
              r?.value ??
              r?.id ??
              r?.reason_id ??
              r?.refund_reason_id ??
              r?.code ??
              r?.key ??
              null;
            const text =
              r?.text ??
              r?.stext ??
              r?.name ??
              r?.title ??
              (value !== null && value !== undefined ? String(value) : "");
            if (value === null || value === undefined || !text) return null;
            return { text, value };
          })
          .filter(Boolean);
      }

      if (typeof source === "object") {
        return Object.keys(source)
          .map((key) => {
            const v = source[key];
            const text =
              (v && typeof v === "object" && (v.stext || v.text || v.name)) ||
              (typeof v === "string" ? v : null) ||
              key;
            return { text, value: key };
          })
          .filter((x) => x && x.value !== undefined && x.value !== null);
      }

      return [];
    };

    const fetchRefundReasonList = async () => {
      if (refundReasonLoaded.value || refundReasonLoading.value) return;
      refundReasonLoading.value = true;
      try {
        const response = await postData({
          method: "orderCancelOperations",
          func: "getRefundReasonList",
        });
        const source =
          (response && !response.error && (response.data || response.result)) ||
          (response && !response.error && typeof response === "object"
            ? response
            : null);
        refundReasonList.value = normalizeRefundReasonList(source);
      } catch (e) {
        refundReasonList.value = [];
      } finally {
        refundReasonLoaded.value = true;
        refundReasonLoading.value = false;
      }
    };

    const normalizeMatchKey = (value) =>
      (value ?? "").toString().trim().replace(/\s+/g, " ").toUpperCase();

    const formatQty = (value) => {
      const num = Number(value);
      if (!Number.isFinite(num)) return "0";
      return String(Number(num.toFixed(3)));
    };

    const normalizeUnit = (value) =>
      (value ?? "")
        .toString()
        .trim()
        .toUpperCase()
        .replace(/İ/g, "I");

    const parseMatUnits = (matunits) => {
      const parts = String(matunits || "")
        .split("#")
        .map((s) => s.trim())
        .filter(Boolean);
      const re =
        /^([\d.,]+)\s*([A-Za-zÇĞİÖŞÜçğıöşü]+)\s*=\s*([\d.,]+)\s*([A-Za-zÇĞİÖŞÜçğıöşü]+)$/;
      const pairs = [];
      parts.forEach((part) => {
        const m = part.match(re);
        if (!m) return;
        const fromQty = Number(String(m[1]).replace(",", "."));
        const toQty = Number(String(m[3]).replace(",", "."));
        const fromUnit = normalizeUnit(m[2]);
        const toUnit = normalizeUnit(m[4]);
        if (!fromQty || !toQty || !fromUnit || !toUnit) return;
        pairs.push({ fromQty, fromUnit, toQty, toUnit });
      });
      return pairs;
    };

    const buildFactorMap = (pairs) => {
      const factors = {};
      const add = (from, to, factor) => {
        if (!from || !to || !Number.isFinite(factor) || factor === 0) return;
        factors[`${from}|${to}`] = factor;
      };
      const units = new Set();
      pairs.forEach((p) => {
        units.add(p.fromUnit);
        units.add(p.toUnit);
        add(p.fromUnit, p.toUnit, p.toQty / p.fromQty);
        add(p.toUnit, p.fromUnit, p.fromQty / p.toQty);
      });
      const list = Array.from(units);
      list.forEach((u) => add(u, u, 1));
      list.forEach((k) => {
        list.forEach((i) => {
          list.forEach((j) => {
            const ik = factors[`${i}|${k}`];
            const kj = factors[`${k}|${j}`];
            if (ik != null && kj != null) {
              add(i, j, ik * kj);
            }
          });
        });
      });
      return factors;
    };

    const matchInvQuantities = (rows) => {
      const map = {};
      const products = orderTrackingStore.viewDialogData?.products || [];
      const usedRowIds = new Set();

      const findRow = (product) => {
        const byId = rows.find((r) => String(r.id) === String(product.id));
        if (byId) return byId;

        const material = normalizeMatchKey(product.prd_code);
        const erp = normalizeMatchKey(product.erporderno);
        return rows.find((r) => {
          if (usedRowIds.has(String(r.id))) return false;
          return (
            normalizeMatchKey(r.material) === material &&
            normalizeMatchKey(r.erporderno) === erp
          );
        });
      };

      products.forEach((product) => {
        const row = findRow(product);
        if (!row) return;
        usedRowIds.add(String(row.id));
        const pairs = parseMatUnits(row.matunits);
        map[product.id] = {
          invquantity: Number(row.invquantity),
          invqunit: normalizeUnit(row.invqunit),
          skunit: normalizeUnit(row.skunit),
          matunits: row.matunits || "",
          pairs,
          factors: buildFactorMap(pairs),
        };
      });

      invQtyMap.value = map;
    };

    const fetchRefundInvQuantityList = async () => {
      const orderId = orderTrackingStore.viewDialogData?.id;
      if (!orderId) {
        throw new Error("Sipariş numarası bulunamadı");
      }

      const response = await postData({
        method: "orderCancelOperations",
        func: "getRefundINVQuantityList",
        order_id: orderId,
      });

      if (!response) {
        throw new Error("Faturalanmış miktarlar alınamadı");
      }
      if (response.error) {
        throw new Error(response.msg || "Faturalanmış miktarlar alınamadı");
      }

      const rows = Array.isArray(response.data) ? response.data : [];
      matchInvQuantities(rows);

      if (Object.keys(invQtyMap.value).length === 0) {
        throw new Error(
          "Sipariş satırları ile faturalanmış miktarlar eşleştirilemedi"
        );
      }
    };

    const getInvInfo = (item) =>
      invQtyMap.value[item?.id] || invQtyMap.value[String(item?.id)] || null;

    const hasFactor = (item, fromUnit, toUnit) => {
      const from = normalizeUnit(fromUnit);
      const to = normalizeUnit(toUnit);
      if (!from || !to) return false;
      if (from === to) return true;
      const factor = getInvInfo(item)?.factors?.[`${from}|${to}`];
      return Number.isFinite(factor);
    };

    const unitInGraph = (item, unit) => {
      const u = normalizeUnit(unit);
      if (!u) return false;
      const inv = getInvInfo(item);
      if (!inv) return false;
      if ((inv.pairs || []).some((p) => p.fromUnit === u || p.toUnit === u)) {
        return true;
      }
      return Object.keys(inv.factors || {}).some(
        (k) => k.startsWith(`${u}|`) || k.endsWith(`|${u}`)
      );
    };

    const getInvUnit = (item) => {
      const inv = getInvInfo(item);
      const invU = inv?.invqunit;
      const sku = inv?.skunit;
      if (invU && (unitInGraph(item, invU) || !sku)) return invU;
      if (sku) return sku;
      return invU || normalizeUnit(item?.birim);
    };

    const convertQty = (item, qty, fromUnit, toUnit) => {
      const from = normalizeUnit(fromUnit);
      const to = normalizeUnit(toUnit);
      const n = Number(qty);
      if (!Number.isFinite(n)) return 0;
      if (!from || !to || from === to) return n;
      const inv = getInvInfo(item);
      let factor = inv?.factors?.[`${from}|${to}`];
      if (factor == null || !Number.isFinite(factor)) {
        const sku = inv?.skunit;
        const a = sku ? inv?.factors?.[`${from}|${sku}`] : null;
        const b = sku ? inv?.factors?.[`${sku}|${to}`] : null;
        if (Number.isFinite(a) && Number.isFinite(b)) factor = a * b;
      }
      if (factor == null || !Number.isFinite(factor)) return n;
      return Number((n * factor).toFixed(4));
    };

    const getUnitOptions = (item) => {
      const inv = getInvInfo(item);
      const units = new Set();
      (inv?.pairs || []).forEach((p) => {
        units.add(p.fromUnit);
        units.add(p.toUnit);
      });
      if (inv?.invqunit) units.add(inv.invqunit);
      if (inv?.skunit) units.add(inv.skunit);
      return Array.from(units).filter(Boolean);
    };

    const canChangeUnit = (item) => getUnitOptions(item).length > 1;

    const getUnitSelectItems = (item) =>
      getUnitOptions(item).map((u) => ({
        value: u,
        text: getUnitTextByCode(u) || u,
      }));

    const getConversionLabels = (item) => {
      const inv = getInvInfo(item);
      const seen = new Set();
      const labels = [];
      (inv?.pairs || []).forEach((p) => {
        const key = [p.fromUnit, p.toUnit].sort().join("|");
        if (seen.has(key)) return;
        seen.add(key);
        labels.push(
          `${formatQty(p.fromQty)} ${getUnitTextByCode(p.fromUnit)} = ${formatQty(
            p.toQty
          )} ${getUnitTextByCode(p.toUnit)}`
        );
      });
      return labels;
    };

    const getReturnUnitCode = (item) => {
      const key = item?.id;
      if (unitChangeMap.value[key] && altUnitMap.value[key]) {
        return altUnitMap.value[key];
      }
      return getInvUnit(item) || item?.birim;
    };

    const getUnitTextByCode = (code) => {
      if (!code) return "";
      const unit = store.state.tanimlar.birim.find(
        (el) => el.value === normalizeUnit(code)
      );
      return unit ? unit.text : code;
    };

    const getUnitText = (item) => getUnitTextByCode(item?.birim);

    const getReturnUnitText = (item) => getUnitTextByCode(getReturnUnitCode(item));

    const getMaxReturnQty = (item) => {
      const inv = getInvInfo(item);
      if (!inv || !Number.isFinite(Number(inv.invquantity))) {
        return Number(item?.qty || 0);
      }
      const qty = Number(inv.invquantity);
      const to = getReturnUnitCode(item);
      const fromInv = inv.invqunit || inv.skunit;
      if (hasFactor(item, fromInv, to)) {
        return convertQty(item, qty, fromInv, to);
      }
      if (inv.skunit && hasFactor(item, inv.skunit, to)) {
        return convertQty(item, qty, inv.skunit, to);
      }
      return qty;
    };

    const qtyErrorMessage = (item) => {
      if (!selectedMap.value[item.id]) return "";
      const val = Number(returnQtyMap.value[item.id]);
      const max = getMaxReturnQty(item);
      if (!Number.isFinite(val) || val <= 0) return "İade miktarı giriniz";
      if (val > max) {
        return `Faturalanmış miktarı (${formatQty(max)} ${getReturnUnitText(
          item
        )}) geçemez`;
      }
      return "";
    };

    // Daha önce iade işlemi başlatılmış/onaylanmış/tamamlanmış satırlar yeniden seçilemesin
    const hasActiveRefund = (item) => {
      const qty = Number(item?.refund_qty || 0);
      const code = (item?.refund_status_code || "")
        .toString()
        .toUpperCase()
        .replace("İ", "I");
      // CNC (Reddedildi) hariç; WAIT/APR/CMP aktif kabul edilir
      if (qty <= 0) return false;
      return code !== "CNC";
    };
    const hasInvQty = (item) => {
      const inv = getInvInfo(item);
      return Boolean(inv && Number(inv.invquantity) > 0);
    };
    const canSelectForReturn = (item) =>
      !hasActiveRefund(item) && hasInvQty(item);

    let invFetchSeq = 0;

    const resetReturnState = () => {
      returnMode.value = false;
      selectedMap.value = {};
      returnQtyMap.value = {};
      reasonMap.value = {};
      invQtyMap.value = {};
      unitChangeMap.value = {};
      altUnitMap.value = {};
      showMissingReasons.value = false;
    };

    const toggleReturnMode = async (reset = false) => {
      if (reset || returnMode.value) {
        invFetchSeq += 1;
        refundInvQtyLoading.value = false;
        resetReturnState();
        return;
      }
      const seq = ++invFetchSeq;
      showMissingReasons.value = false;
      refundInvQtyLoading.value = true;
      try {
        await Promise.all([
          fetchRefundReasonList(),
          fetchRefundInvQuantityList(),
        ]);
        if (seq !== invFetchSeq || !orderTrackingStore.viewDialogModel) {
          return;
        }
        returnMode.value = true;
        (orderTrackingStore.viewDialogData?.products || [])
          .filter((p) => p?.id !== undefined && canSelectForReturn(p))
          .forEach((p) => {
            Vue.set(selectedMap.value, p.id, false);
          });
      } catch (e) {
        if (seq !== invFetchSeq) return;
        resetReturnState();
        Vue.swal({
          title: "Hata",
          text: e.message || "Faturalanmış miktarlar alınamadı",
          icon: "error",
          width: "380px",
          background: "#FF4C51",
          confirmButtonColor: "#cc3d41",
          confirmButtonText: "Tamam",
        });
      } finally {
        if (seq === invFetchSeq) {
          refundInvQtyLoading.value = false;
        }
      }
    };

    const onCheckboxChange = (item, val) => {
      const key = item.id;
      if (val) {
        Vue.set(returnQtyMap.value, key, getMaxReturnQty(item));
        Vue.set(unitChangeMap.value, key, false);
        Vue.set(altUnitMap.value, key, getInvUnit(item));
        if (reasonMap.value[key] === undefined) {
          Vue.set(reasonMap.value, key, null);
        }
      } else {
        Vue.delete(returnQtyMap.value, key);
        Vue.delete(reasonMap.value, key);
        Vue.delete(unitChangeMap.value, key);
        Vue.delete(altUnitMap.value, key);
      }
    };

    const onUnitChangeToggle = (item, enabled) => {
      const key = item.id;
      const currentUnit = getReturnUnitCode(item);
      Vue.set(unitChangeMap.value, key, !!enabled);
      if (enabled) {
        const target = altUnitMap.value[key] || getInvUnit(item);
        Vue.set(altUnitMap.value, key, target);
        const qty = Number(returnQtyMap.value[key] || 0);
        Vue.set(
          returnQtyMap.value,
          key,
          convertQty(item, qty, currentUnit, target)
        );
        return;
      }
      const from = altUnitMap.value[key] || currentUnit;
      const invUnit = getInvUnit(item);
      const qty = Number(returnQtyMap.value[key] || 0);
      Vue.set(returnQtyMap.value, key, convertQty(item, qty, from, invUnit));
      Vue.set(altUnitMap.value, key, invUnit);
    };

    const onAltUnitChange = (item, newUnit) => {
      const key = item.id;
      const oldUnit = altUnitMap.value[key] || getInvUnit(item);
      const qty = Number(returnQtyMap.value[key] || 0);
      Vue.set(returnQtyMap.value, key, convertQty(item, qty, oldUnit, newUnit));
      Vue.set(altUnitMap.value, key, newUnit);
    };

    const clampQty = (item) => {
      const key = item.id;
      let val = Number(returnQtyMap.value[key]);
      if (!Number.isFinite(val) || val < 0) {
        Vue.set(returnQtyMap.value, key, 0);
      }
    };

    const selectedLines = computed(() => {
      if (!orderTrackingStore.viewDialogData?.products) return [];
      return orderTrackingStore.viewDialogData.products
        .map((p) => {
          const key = p.id;
          if (!selectedMap.value[key]) return null;
          return {
            id: key,
            return_qty: Number(returnQtyMap.value[key] || 0),
            max_qty: getMaxReturnQty(p),
            birim: getReturnUnitCode(p),
            title: p.baslik,
          };
        })
        .filter(Boolean);
    });

    const selectedCount = computed(() => selectedLines.value.length);
    const isValidSelection = computed(() =>
      selectedLines.value.every(
        (l) =>
          Number.isFinite(l.return_qty) &&
          l.return_qty > 0 &&
          l.return_qty <= l.max_qty
      )
    );
    const missingReasonIds = computed(() =>
      selectedLines.value.map((l) => l.id).filter((id) => !reasonMap.value[id])
    );
    const hasMissingReasons = computed(() => missingReasonIds.value.length > 0);

    // İade butonunu gösterme durumu (sipariş BAŞARILI ise)
    const canShowReturnButton = computed(() => {
      const statusText = (
        orderTrackingStore.viewDialogData?.order_status_text || ""
      )
        .toString()
        .toUpperCase();
      const statusColor = (
        orderTrackingStore.viewDialogData?.order_status || ""
      )
        .toString()
        .toLowerCase();
      return statusText.includes("BAŞARILI") || statusColor === "success";
    });

    // URL'de 'test2' varsa (örn: /test2/order-tracking) iade butonu görünsün
    const isTest2Url = computed(() => {
      try {
        return typeof window !== "undefined" && window.location.pathname.includes("test2");
      } catch (e) {
        return false;
      }
    });

    // İade durum kodu haritalaması
    const REFUND_STATUS_MAP = {
      WAIT: { stext: "Onay Bekliyor", type: "warning" },
      CNC: { stext: "Reddedildi", type: "error" },
      APR: { stext: "Kabul edildi", type: "info" },
      CMP: { stext: "Tamamlandı", type: "success" },
    };
    const refundStatusMeta = (code, fallbackText) => {
      const normalized = (code || "").toString().toUpperCase().replace("İ", "I");
      const meta = REFUND_STATUS_MAP[normalized];
      return {
        color: meta ? meta.type : "info",
        text: meta ? meta.stext : (fallbackText || ""),
      };
    };

    const createReturnRequest = async () => {
      if (selectedCount.value === 0) {
        Vue.swal({
          title: "Uyarı",
          text: "Lütfen iade etmek istediğiniz ürünleri seçiniz.",
          icon: "warning",
          width: "350px",
          /* background: "#EBF5FF", */
          background: "#FFB400",
          confirmButtonText: "Tamam",
        });
        return;
      }
      showMissingReasons.value = false;

      const overLimitLines = selectedLines.value.filter(
        (l) => !Number.isFinite(l.return_qty) || l.return_qty <= 0 || l.return_qty > l.max_qty
      );
      if (overLimitLines.length > 0) {
        const first = overLimitLines[0];
        const overMax = first.return_qty > first.max_qty;
        Vue.swal({
          title: "Hata",
          text: overMax
            ? `"${first.title}" için iade miktarı faturalanmış miktarı (${formatQty(
                first.max_qty
              )} ${getUnitTextByCode(first.birim)}) geçemez.`
            : "Lütfen geçerli bir iade miktarı giriniz.",
          icon: "error",
          width: "380px",
          background: "#FF4C51",
          confirmButtonColor: "#cc3d41",
          confirmButtonText: "Tamam",
        });
        return;
      }

      if (!refundReasonLoaded.value) {
        await fetchRefundReasonList();
      }
      if (refundReasonList.value.length === 0) {
        Vue.swal({
          title: "Uyarı",
          text: "İade nedeni listesi alınamadı. Lütfen daha sonra tekrar deneyiniz.",
          icon: "warning",
          width: "380px",
          background: "#FFB400",
          confirmButtonText: "Tamam",
        });
        return;
      }
      if (hasMissingReasons.value) {
        showMissingReasons.value = true;
        Vue.swal({
          title: "Uyarı",
          text: "Lütfen seçili ürünler için iade nedeni seçiniz.",
          icon: "warning",
          width: "380px",
          background: "#FFB400",
          confirmButtonText: "Tamam",
        });
        return;
      }

      const confirm = await Vue.swal({
        title: "Emin misiniz?",
        html: `Seçili <strong>${selectedCount.value}</strong> ürün için iade talebi oluşturulsun mu?`,
        icon: "question",
        width: "360px",
        showCancelButton: true,
        confirmButtonText: "Evet",
        cancelButtonText: "Vazgeç",
        background: "#1E1E2D",
        confirmButtonColor: "#1e88e5",
        cancelButtonColor: "#424242",
      });

      if (!confirm.isConfirmed) return;

      try {
        orderTrackingStore.viewDialogLoading = true;
        // Son değerleri normalize edip gönderelim
        const linesToSend = orderTrackingStore.viewDialogData.products
          .filter((p) => selectedMap.value[p.id])
          .map((p) => {
            const key = p.id;
            const max = getMaxReturnQty(p);
            const val = Number(returnQtyMap.value[key] || 0);
            if (!Number.isFinite(val) || val <= 0) {
              throw new Error("Lütfen geçerli bir iade miktarı giriniz.");
            }
            if (val > max) {
              throw new Error(
                `"${p.baslik}" için iade miktarı faturalanmış miktarı (${formatQty(
                  max
                )} ${getReturnUnitText(p)}) geçemez.`
              );
            }
            return {
              id: key,
              qty: val,
              birim: getReturnUnitCode(p),
              reason_id: reasonMap.value[key],
            };
          });
        const payload = {
          method: "orderCancelOperations",
          func: "createReturnRequest",
          order_id: orderTrackingStore.viewDialogData.id,
          lines: JSON.stringify(linesToSend),
        };

        const response = await postData(payload);
        if (response?.error) {
          throw new Error(response.msg || "İşlem başarısız");
        }

        await Vue.swal({
          title: "Başarılı",
          text: "İade talebiniz oluşturuldu",
          icon: "success",
          width: "350px",
          background: "#1E1E2D",
          confirmButtonText: "Kapat",
          timerProgressBar: true,
        });
        toggleReturnMode(true);
        // Dialog'ı kapat
        orderTrackingStore.viewDialogClose();
      } catch (e) {
        Vue.swal({
          title: "Hata",
          text: e.message,
          icon: "error",
          width: "350px",
          background: "#FF4C51",
          confirmButtonColor: "#cc3d41",
        });

      } finally {
        orderTrackingStore.viewDialogLoading = false;

      }
    };

    watch(
      () => orderTrackingStore.viewDialogModel,
      (open) => {
        if (!open) {
          invFetchSeq += 1;
          refundInvQtyLoading.value = false;
          resetReturnState();
        }
      }
    );

    return {
      ERP_ORDER_TYPE_DETAILS,

      parseJson,
      userData,
      deleteItem,
      orderTrackingStore,
      scrollableEl,
      isScroll,
      arrivedState,
      // Return
      returnMode,
      selectedMap,
      returnQtyMap,
      reasonMap,
      refundReasonList,
      refundReasonLoading,
      refundInvQtyLoading,
      showMissingReasons,
      toggleReturnMode,
      onCheckboxChange,
      clampQty,
      createReturnRequest,
      selectedCount,
      isValidSelection,
      hasMissingReasons,
      getUnitText,
      getReturnUnitText,
      getMaxReturnQty,
      formatQty,
      qtyErrorMessage,
      canChangeUnit,
      unitChangeMap,
      altUnitMap,
      getUnitSelectItems,
      getConversionLabels,
      onUnitChangeToggle,
      onAltUnitChange,
      canShowReturnButton,
      isTest2Url,
      refundStatusMeta,
      canSelectForReturn,
      // icons
      icons: {
        mdiClose,
        mdiTrashCan,
        mdiCalendarClock,
        mdiCameraOff,
        mdiDeleteOutline,
        mdiUndoVariant,
        mdiInformationVariantCircle,
      },
    };
  },
};
</script>
